import { setAuthState } from './auth';

export const YOUR_JOURNEY = 'your-journey';

// Your Journey replaces Home only for users who have finished onboarding. Everyone else is
// already routed into onboarding before `/` renders, so the second check keeps mid-onboarding
// users on today's path should they ever reach Home.
export const isYourJourneyEnabled = () => {
	const { userHaveAccessTo, isOnboardingComplete } = setAuthState();

	return userHaveAccessTo(YOUR_JOURNEY) && isOnboardingComplete();
};
